<template>
  <WCSinglePageFormContainer>
    <WCResetPasswordForm v-if="!key" @submit="submitResetForm" />

    <WCVerificationCodeForm v-if="key && !potentialAccounts" @submit="submitVerificationForm" />

    <WCMultipleAccounts
      v-if="potentialAccounts"
      :accounts="potentialAccounts"
      @select="submitVerificationFormForAccount"
      @cancel="reset"
    />
  </WCSinglePageFormContainer>
</template>

<script>
import axios from 'axios';
import WCSinglePageFormContainer from '@/modules/forms/components/WCSinglePageFormContainer/WCSinglePageFormContainer.vue';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import WCResetPasswordForm from '@/modules/user/components/WCResetPasswordForm/WCResetPasswordForm.vue';
import WCVerificationCodeForm from '@/modules/user/components/WCVerificationCodeForm/WCVerificationCodeForm.vue';
import WCMultipleAccounts from '@/modules/user/components/WCMultipleAccounts/WCMultipleAccounts.vue';

export default {
  components: {
    WCSinglePageFormContainer,
    WCResetPasswordForm,
    WCVerificationCodeForm,
    WCMultipleAccounts,
  },
  data() {
    return {
      key: null,
      potentialAccounts: null,
      code: '',
    };
  },
  methods: {
    async submitResetForm(form) {
      const contact = form.resetMethod === 'EMAIL' ? form.email : form.phone;
      const request = { method: form.resetMethod, contact };

      try {
        const response = await axios.post('api/password-reset', request);
        this.key = response.data.data;
      } catch (error) {
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : this.$t('passwordResetError');
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('error'),
            message,
          },
          timeout: 7000,
        });
      }
    },
    async submitVerificationForm(form) {
      const request = { key: this.key, code: form.code };
      try {
        const response = await axios.post('api/password-reset/verify', request);
        if (typeof response.data.data === 'string') {
          // TODO: Vue 3 handle router errors
          this.$router
            .replace({ name: 'RecoverPassword', params: { token: response.data.data } })
            .catch(() => {});
        } else {
          this.potentialAccounts = response.data.data;
          this.code = form.code;
        }
      } catch (error) {
        console.error(error);
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : this.$t('failedVerification');
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('error'),
            message,
          },
          timeout: 7000,
        });
      }
    },
    async submitVerificationFormForAccount(account) {
      const request = { key: this.key, code: this.code };
      try {
        const response = await axios.post(`api/password-reset/verify/${account.id}`, request);
        if (typeof response.data.data === 'string') {
          // TODO: Vue 3 handle router errors
          this.$router
            .replace({ name: 'RecoverPassword', params: { token: response.data.data } })
            .catch(() => {});
        }
      } catch (error) {
        console.error(error);
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : this.$t('failedPasswordResetError');
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('error'),
            message,
          },
          timeout: 7000,
        });
      }
    },
    reset() {
      this.key = null;
      this.potentialAccounts = null;
      this.code = null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
